import { useMemo } from 'react';

import { useFormTemplatesByUidMap, usePgUser, useUserPermissionInfo } from '.';
import { FORM_TEMPLATE_PERMISSIONS, FORM_STATUSES } from '../helpers/constants';
import { checkUserPermissionOnTemplate } from '../helpers/utils';

export default (onRemove, form) => {
  const { status, type: templateId } = form;
  const { data: allTemplates } = useFormTemplatesByUidMap();
  const { data: pgUser } = usePgUser();
  const { data: userPermissionInfo } = useUserPermissionInfo(
    pgUser && pgUser.user_id,
  );
  const template = allTemplates && allTemplates[templateId];

  return useMemo(() => {
    if (!onRemove) {
      return false;
    }

    if ([FORM_STATUSES.SUBMITTED, FORM_STATUSES.ARCHIVED].includes(status)) {
      return false;
    }

    if (status === FORM_STATUSES.IN_REVIEW) {
      const canManage = checkUserPermissionOnTemplate(
        userPermissionInfo,
        template,
        FORM_TEMPLATE_PERMISSIONS.MANAGE,
      );
      const canReview = checkUserPermissionOnTemplate(
        userPermissionInfo,
        template,
        FORM_TEMPLATE_PERMISSIONS.APPROVE,
      );

      return canManage || canReview;
    }

    return true;
  }, [onRemove, status, userPermissionInfo, template]);
};
